var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('HeaderBar'),_c('main',{staticClass:"main-page"},[_c('keep-alive',{key:_vm.key,attrs:{"include":_vm.keepAlivePageName}},[_c('router-view',{key:_vm.key})],1)],1),_c('FooterBar'),(_vm.noticeData)?_c('NoticeAlert',{attrs:{"notice":_vm.noticeData},on:{"closed":_vm.handleNoticeClosed}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }